import React from 'react';
const stats = [['6', 'Premium Volumes'], ['50+', 'Ready-to-Teach Drills'], ['12', 'Week Complete Program'], ['8', 'Core Step Patterns'], ['5', 'Bonus Resource Kits'], ['0h', 'Prep From Scratch']];
export function StatsBar() {
  return <section className="w-full bg-mist px-4 py-10 sm:py-12" data-id="element-215" data-mp="1odhyz6z2q33e">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-6" data-id="element-216" data-mp="1jb94g66jysz6">
        {stats.map(([value, label]) => <div key={label} data-id="element-217" data-mp="19mit43pmhsni">
            <div className="font-display text-4xl font-extrabold text-green-dark" data-id="element-218" data-mp="19m91kboxjdfp">{value}</div>
            <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.13em] text-ink/70 sm:text-xs" data-id="element-219" data-mp="15ke2lduh1c53">{label}</div>
          </div>)}
      </div>
    </section>;
}